import React from "react";
import DRIBBLEICON from "../assets/icons/dribble.png";
import WEBSITEICON from "../assets/icons/web.png";
import LINKEDINICON from "../assets/icons/linkedin.png";

import { FacebookRounded, GitHub, Pinterest } from "@mui/icons-material";
import { Box } from "@mui/material";

export const profiles = [
  {
    name: "LinkedIn",
    icon: (
      <Box component="img" src={LINKEDINICON} sx={{ width: 40, height: 40 }} />
    ),
    bgColor: "#F1F5F9",
    iconColor: "#0077B5",
    buttonBg: "#0077B5",
  },
  {
    name: "Facebook",
    icon: <FacebookRounded sx={{ zIndex: 400, fontSize: 44 }} />,
    bgColor: "#F1F5F9",
    iconColor: "#0077B5",
    buttonBg: "#0077B5",
  },
  {
    name: "Github",
    icon: <GitHub sx={{ fontSize: 44 }} />,
    bgColor: "#F5F5F5",
    iconColor: "#171515",
    buttonBg: "#000000",
  },
  {
    name: "Pinterest",
    icon: <Pinterest sx={{ fontSize: 44 }} />,
    bgColor: "#FEF2F2",
    iconColor: "#E60023",
    buttonBg: "#E60023",
  },
  {
    name: "Website",
    icon: (
      <Box component="img" src={WEBSITEICON} sx={{ width: 40, height: 40 }} />
    ),
    bgColor: "#F8F9FA",
    iconColor: "#000000",
    buttonBg: "#000000",
  },
  {
    name: "Dribble",
    key: "Dribble",
    icon: (
      <Box component="img" src={DRIBBLEICON} sx={{ width: 44, height: 44 }} />
    ),
    bgColor: "#F5F5F5",
    iconColor: "#eb2e97",
    buttonBg: "#eb2e97",
  },
];
